import { creditCardDetailsEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import { css } from "styled-components";

creditCardDetailsEntryStyles.creditCardDetailsHeading = {
    variant: "h5",
    css: css`
        margin-bottom: 0px;
        margin-top: 10px;
        font-family: "LatoBold";
    `,
};
